export default{
    callSetFeedback({commit, dispatch}, objectItem){
        commit('SET_FEEDBACK_ITEM', objectItem)
    }
}